import { render } from "./SharedFSTab.vue?vue&type=template&id=08ef114a&scoped=true"
import script from "./SharedFSTab.vue?vue&type=script&lang=js"
export * from "./SharedFSTab.vue?vue&type=script&lang=js"

import "./SharedFSTab.vue?vue&type=style&index=0&id=08ef114a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ef114a"]])

export default __exports__